import React from 'react';
import { IconCheck } from '@bynder/icons';
import { CSRF } from '../../../helpers/csrf';
import { iconSizeMedium } from '../../../helpers/iconSizes';

export function LanguageItemOLD({
	isActive,
	className,
	locale,
	localeFullName,
}: {
	isActive: boolean;
	className: string;
	locale: string;
	localeFullName: string;
}) {
	/*
	 * We are keeping the form in order not to break custom theming.
	 * The change language event is handled in the parent component through the onChangeLanguage prop
	 */

	const formId = `${locale}-language-item-form`;

	const onChangeLanguage = () => {
		(document.querySelector(`#${formId}`) as HTMLFormElement)?.submit();
	};

	return (
		<li className={className}>
			<form action="/user/switchlanguage/" method="post" id={formId}>
				<input name="csrf" value={CSRF} type="hidden" />
				<input name="language" value={locale} type="hidden" />

				<a href="#" className="admin-option" dir="ltr" onClick={onChangeLanguage}>
					{localeFullName}
					{isActive && <IconCheck size={iconSizeMedium} />}
				</a>
			</form>
		</li>
	);
}
